export default function Hotspot({ brand, onComingSoon }) {
    const h = brand.hotspot;
    const style = {
        left: `${h.left}%`,
        top: `${h.top}%`,
        width: `${h.width}%`,
        height: `${h.height}%`,
    };
    const isActive = brand.status === "active";
    const label = isActive ? "Visit Website" : "Coming Soon";

    const inner = (
        <>
            <img
                src={brand.logo}
                alt=""
                aria-hidden="true"
                className={`hotspot-logo ${brand.logoShape === "wide" ? "wide" : ""}`}
            />
            <span className={`hotspot-label ${isActive ? "" : "coming-soon"}`}>{label}</span>
        </>
    );

    const testId = `teg-brand-hotspot-${brand.id}`;

    if (isActive) {
        return (
            <>
                <a
                    href={brand.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="brand-hotspot"
                    style={style}
                    aria-label={`${brand.name} — Visit Website (opens in a new tab)`}
                    data-testid={testId}
                >
                    {inner}
                </a>
                {brand.bookingUrl && (
                    <a
                        href={brand.bookingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ti-book-call"
                        style={{
                            left: `${h.left}%`,
                            top: "85.5%",
                            width: `${h.width}%`,
                            height: "4.6%",
                        }}
                        aria-label={`${brand.name} — Book a Call (opens in a new tab)`}
                        data-testid="teg-book-call-hotspot"
                    >
                        Book a Call
                    </a>
                )}
            </>
        );
    }
    return (
        <button
            type="button"
            className="brand-hotspot"
            style={style}
            onClick={() => onComingSoon(brand)}
            aria-label={`${brand.name} — Coming Soon`}
            data-testid={testId}
        >
            {inner}
        </button>
    );
}
